angular.module("app").controller("HiddenGamesListPageController", [
    '$scope',
    'preloadedProviders',
    'preloadedCategories',
    'hiddenGamesService',
    'errorHandler',
    'logger',
    function ($scope, preloadedProviders, preloadedCategories, hiddenGamesService, errorHandler, logger) {
        $scope.tabOptions = {};
        preloadedCategories.items.forEach(function (value) {
            value.hidden = !value.hidden;
        });

        preloadedProviders.items.forEach(function (value) {
            value.hidden = !value.hidden;
        });

        $scope.categories = angular.copy(preloadedCategories.items);
        $scope.providers = angular.copy(preloadedProviders.items);

        $scope.getDateTime = function (dateString) {
            return new Date(dateString).getTime()
        };

        $scope.changeTheValue = function (item, isProvider) {
            var fn = hiddenGamesService["update" + (isProvider ? 'Provider' : 'Category')],
                requestData = {
                    visibility: {
                        id: item.id,
                        hidden: !item.hidden
                    }
                };
            fn(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess('global.successfullyUpdated')
                    } else {
                        item.hidden = !item.hidden;
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    item.hidden = !item.hidden;
                    errorHandler(response.message)
                }
            );
        };


        $scope.allowUpdateProviders = function (options) {
            if (options && options.autoUpdate) {
                reorder($scope.providers, hiddenGamesService.changeProviderOrder);
            } else if (!!options) {
                $scope.tabOptions.reorderedProviders = true
            }
        };

        $scope.allowUpdateCategories = function (options) {
            if (options && options.autoUpdate) {
                reorder($scope.categories, hiddenGamesService.changeCategoryOrder);
            } else if (!!options) {
                $scope.tabOptions.reorderedCategories = true
            }
        };

        function reorder (listOfValues, serviceFunction) {
            if (typeof listOfValues === "object" && listOfValues.length) {
                var list = [];
                listOfValues.forEach(function (item) {
                    list.push(item.id);
                });
                serviceFunction({order: list}).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("global.updated")
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            }
        }
    }
]);